if (!customElements.get("highlight-text-image")) {
  class HighLightTextImage extends HTMLElement {
    constructor() {
      super();
      this.sectionId = this.dataset.sectionId;
      this.section = this.closest(`.section-${this.sectionId}`) || this.closest(`[data-section-id="${this.sectionId}"]`);
      const templateEl = this.section ? this.section.querySelector("template") : null;
      this.templates = templateEl ? templateEl.content.cloneNode(true) : null;
      this.images = {};
      this.init();
    }

    connectedCallback() {}

    init() {
      if (!this.templates) return;
      let contentHTML = this.innerHTML;
      this.templates.querySelectorAll("[data-id]").forEach((image) => {
        const key = image.dataset.id;
        this.images[key] = image;
      });

      contentHTML = contentHTML.replace(/\[img(\d+)\]/g, (match, p1) => {
        const imgIndex = `img${p1}`;
        const imageWrapper = this.images[imgIndex];
        return imageWrapper ? imageWrapper.innerHTML : match;
      });

      this.innerHTML = contentHTML;
    }
  }

  customElements.define("highlight-text-image", HighLightTextImage);
}
